export enum GridFilterType {
  TEXT = 'agTextColumnFilter',
  NUMBER = 'agNumberColumnFilter',
  DATE = 'agDateColumnFilter',
  DATETIME = 'customDateTime',
  SET = 'agSetColumnFilter',
  MAPLECROFT_RISK_VIEW = 'customMaplecroftRiskViewFilter',
}
